// import { useState, useEffect } from "react";
import { CSSProperties, use, useMemo, useState } from "react";
import { Modal, Frame, TitleBar, DataTable, Button, Tree } from "@react95/core";

import Moment from "react-moment";

import {
  Regedit,
  Regedit205,
  Regedit206,
  FilePick,
  Mailnews8,
  Mapi32801,
  HtmlPage,
  Shell32147,
  Wmsui323936,
  Shell325,
  Shell324,
  Wmsui322221,
  Syncui125,
  Wgpocpl128,
  Wmsui325901,
  Lock,
  Mail,
  Mailnews14,
} from "@react95/icons";

import { useApp } from "../../context/AppContext";
import { useMail, MailMessage } from "../../context/MailContext";

import { WINDOW_NAMES } from "../../config/const";
import { getModalSizeProps } from "../../config/window";

export const MailClientDef = {
  id: WINDOW_NAMES.MailClient,
  title: "Windoze Mail",
  icon: <Mapi32801 variant="16x16_4" />,
  hasButton: true,
};

type MailClientPanelProps = {
  data: MailMessage[];
  columns: { key: string; label: string; width?: string }[];
};

function MailClientPanel(props: MailClientPanelProps) {
  const { loading, readEmail } = useMail();

  const [selectedEmailId, setSelectedEmailId] = useState<string | null>(null);

  const handleEmailClick = (emailId: string) => {
    setSelectedEmailId(emailId);
    readEmail(emailId);
  };

  const columns = props.columns;

  const data = props.data.map((email) => ({
    id: email.id,
    isActive: email.id === selectedEmailId,
    subject: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        {!email.isRead ? (
          <Mail variant="16x16_4" style={{ flexShrink: 0 }} />
        ) : (
          <Mailnews14 variant="16x16_4" style={{ flexShrink: 0 }} />
        )}
        <span style={{ fontWeight: email.isRead ? "normal" : "bold" }}>{email.subject}</span>
      </div>
    ),
    from: <span style={{ fontWeight: email.isRead ? "normal" : "bold" }}>{email.from}</span>,
    recieved: email.timestamp ? (
      <span style={{ fontWeight: email.isRead ? "normal" : "bold" }}>
        <Moment fromNow ago>
          {new Date(email.timestamp)}
        </Moment>{" "}
        ago
      </span>
    ) : (
      <span style={{ fontWeight: email.isRead ? "normal" : "bold" }}>Unknown</span>
    ),
  }));

  const selectedEmail = useMemo(() => {
    return props.data.find((email) => email.id === selectedEmailId) || null;
  }, [selectedEmailId, props.data]);

  if (loading) {
    return <div style={{ padding: "8px" }}>loading mail...</div>;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div style={{ flex: selectedEmail ? "0 0 40%" : "1", minHeight: "100px" }}>
        <DataTable
          columns={columns}
          data={data}
          onRowClick={(row) => handleEmailClick(row.id as string)}
          style={{
            width: "100%",
          }}
        />
      </div>

      {selectedEmail && (
        <div
          style={{
            flex: "1",
            overflowY: "auto",
            borderTop: "1px solid #808080",
            minHeight: 0,
          }}
        >
          <div
            style={{
              padding: "6px 8px",
              fontSize: "12px",
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              backgroundColor: "#c0c0c0",
              borderBottom: "1px solid #808080",
            }}
          >
            <div>
              <strong>From:</strong> {selectedEmail.from}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "8px",
              }}
            >
              <div style={{ flex: "1", minWidth: "200px" }}>
                <strong>Subject:</strong> {selectedEmail.subject}
              </div>
              <div style={{ whiteSpace: "nowrap" }}>
                {selectedEmail.timestamp && (
                  <>
                    <Moment fromNow ago>
                      {new Date(selectedEmail.timestamp)}
                    </Moment>{" "}
                    ago
                  </>
                )}
              </div>
            </div>
          </div>
          <div
            style={{
              padding: "8px",
              whiteSpace: "pre-wrap",
              fontSize: "12px",
            }}
          >
            {selectedEmail.body || "No message body"}
          </div>
        </div>
      )}
    </div>
  );
}

function InboxPanel() {
  const { emails } = useMail();

  const columns = [
    { key: "subject", label: "Subject" },
    { key: "from", label: "From" },
    { key: "recieved", label: "Recieved", width: "120px" },
  ];

  const mailData = useMemo(() => {
    return emails;
  }, [emails]);

  return <MailClientPanel data={mailData} columns={columns} />;
}

function SentPanel() {
  const columns = [
    { key: "subject", label: "Subject" },
    { key: "to", label: "To" },
    { key: "recieved", label: "Recieved", width: "120px" },
  ];

  const mailData = []

  return <MailClientPanel data={mailData} columns={columns} />;
}

function DeletedPanel() {
  const columns = [
    { key: "subject", label: "Subject" },
    { key: "to", label: "To" },
    { key: "recieved", label: "Recieved", width: "120px" },
  ];

  const mailData = []

  return <MailClientPanel data={mailData} columns={columns} />;
}

function TopButtonToolbar() {
  const { fetchMail, loading } = useMail();

  const buttonStyle: CSSProperties = {
    height: "55px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "11px",
    gap: "2px",
  };

  return (
    <Frame
      w="200px"
      h="55px"
      bgColor="$material"
      // boxShadow="$out"
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "4px",
        marginBottom: "4px",
        margin: "2px",
      }}
    >
      <Button style={buttonStyle} disabled>
        <Wmsui322221 variant="32x32_4" />
        New Mail
      </Button>
      <Button style={buttonStyle} onClick={fetchMail} disabled={loading}>
        <Wmsui325901 variant="32x32_4" />
        Fetch Mail
      </Button>
    </Frame>
  );
}

function BottomStatusBar() {
  const { emails } = useMail();

  const statusStyle: CSSProperties = {
    display: "flex",
    marginLeft: "1px",
    marginRight: "1px",
    paddingLeft: "4px",
    paddingRight: "4px",
    paddingTop: "4px",
    fontSize: "12px",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        marginTop: "2px",
      }}
    >
      <Frame
        boxShadow="$in"
        h="20px"
        style={{
          ...statusStyle,
          width: "25%",
        }}
      >
        <div>{emails.length} message(s)</div>
      </Frame>
      <Frame
        boxShadow="$in"
        h="20px"
        style={{
          ...statusStyle,
          flexGrow: 1,
          fontSize: "12px",
        }}
      ></Frame>
      <Frame
        boxShadow="$in"
        h="20px"
        style={{
          ...statusStyle,
          flexGrow: 1,
          fontSize: "12px",
        }}
      ></Frame>
      <Frame
        boxShadow="$in"
        h="20px"
        style={{
          ...statusStyle,
          fontSize: "12px",
        }}
      >
        <div></div>
      </Frame>
      <Frame
        boxShadow="$in"
        h="20px"
        style={{
          ...statusStyle,
          fontSize: "12px",
        }}
      >
        <Lock variant="16x16_4" />
      </Frame>
      <Frame
        boxShadow="$in"
        h="20px"
        w="16px"
        style={{
          ...statusStyle,
          fontSize: "12px",
        }}
      ></Frame>
    </div>
  );
}

export default function MailClient() {
  const { closeModal } = useApp();
  const icon = MailClientDef.icon;
  const sizeProps = useMemo(
    () => getModalSizeProps("350px", "550px", "normal", "240px", "450px"),
    [],
  );

  const [selectedFolder, setSelectedFolder] = useState<string | null>("inbox");

  function folderIcon(selected: boolean) {
    if (selected) return <Shell325 variant="16x16_4" />;
    return <Shell324 variant="16x16_4" />;
  }

  const treeNodeData = [
    {
      id: 1,
      label: "Inbox",
      icon: folderIcon(selectedFolder === "inbox"),
      onClick: () => setSelectedFolder("inbox"),
    },
    {
      id: 3,
      label: "Sent Items",
      icon: folderIcon(selectedFolder === "sentitems"),
      onClick: () => setSelectedFolder("sentitems"),
    },
    {
      id: 4,
      label: "Deleted Items",
      icon: folderIcon(selectedFolder === "deleteditems"),
      onClick: () => setSelectedFolder("deleteditems"),
    },
  ];

  const root = {
    id: 6,
    label: "Folders",
    icon: <Wmsui323936 variant="16x16_4" />,
  };

  return (
    <Modal
      key={MailClientDef.id}
      id={MailClientDef.id}
      icon={icon}
      title={MailClientDef.title}
      dragOptions={sizeProps.dragOptions}
      titleBarOptions={[
        <Modal.Minimize key="minimize" />,
        <TitleBar.Close key="close" onClick={() => closeModal(MailClientDef.id)} />,
      ]}
      defaultClosed={true}
      height={sizeProps.height}
      width={sizeProps.width}
      isResizeable={true}
      minWidth={sizeProps.minWidth}
      minHeight={sizeProps.minHeight}
    >
      <TopButtonToolbar />
      <Frame
        w="100%"
        style={{
          display: "flex",
          flex: 1,
          minHeight: 0,
          flexDirection: "row",
        }}
      >
        <Frame
          bgColor="white"
          boxShadow="$in"
          style={{ margin: "2px", width: "145px", overflowY: "auto", minWidth: "115px" }}
        >
          <Tree root={root} data={treeNodeData} />
        </Frame>

        <Frame
          bgColor="white"
          boxShadow="$in"
          style={{
            margin: "2px",
            padding: "0px",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            overflow: "hidden",
          }}
        >
          {selectedFolder === "inbox" && <InboxPanel />}
          {selectedFolder === "sentitems" && <SentPanel />}
          {selectedFolder === "deleteditems" && <DeletedPanel />}
        </Frame>
      </Frame>

      <BottomStatusBar />
    </Modal>
  );
}
